import { render, staticRenderFns } from "./vehicleRoadTax.vue?vue&type=template&id=caaa6a24"
import script from "./vehicleRoadTax.vue?vue&type=script&lang=js"
export * from "./vehicleRoadTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports